// extracted by mini-css-extract-plugin
export default {"editableCheckbox":"LqwCThFqPqiXfPuDf7T1","inlineLabel":"lDhjCiSb30vuM5j9Izvv","inline":"vqOV5NMiTpVGWVZPFTxA"};